module.exports = __webpack_public_path__ + "img/logo_text.1a7dab29.png";